import React from "react";

import { Paper } from "@mui/material";

function RightSectionLayout({
  hasShadow = true,
  padding = "10px",
  children,
  height = "100%",
}) {
  return (
    <Paper
      data-testid="right-section-layout"
      style={{
        borderRadius: "8px",
        width: "100%",
        padding,
        height,
        boxShadow: "0px 0px 8px 0px rgba(51, 116, 185, 0.25)",
      }}
      elevation={hasShadow && 0}
    >
      {children}
    </Paper>
  );
}

export default RightSectionLayout;
